exports.install = function (Vue, travelService) {
  if (this.installed) {
    return
  }

  this.installed = true

  Vue.travelService = travelService

  Object.defineProperty(Vue.prototype, '$travelService', {
    get: function get () { return travelService }
  })
}



// WEBPACK FOOTER //
// ./src/services/travel-service/plugin.js